<template>
    <el-container class="guide">
        <el-header>
            <Header></Header>
        </el-header>
        <el-main>
            <div class="guide-content">
                <h2><i class="fa fa-map" aria-hidden="true"></i> &nbsp;<span style="color: #db5634">bibite</span> 新手指南</h2>
                <div class="guide-step">
                    <h4><i class="el-icon-user-solid"></i> 步骤一：</h4>
                    <div class="step-content">
                        <p>先在平台上注册自己的账户，注册成功后登录。</p>
                    </div>
                </div>
                <div class="guide-step">
                    <h4><i class="el-icon-edit"></i> 步骤二：</h4>
                    <div class="step-content">
                        <p>登录成功后，正式使用服务前双方需要签署正式合约, 以明确各方的权益, 风险及职责, 为双方合作奠定良好基础。</p>
                    </div>
                </div>
                <div class="guide-step">
                    <h4><i class="el-icon-paperclip"></i> 步骤三：</h4>
                    <div class="step-content">
                        <p>绑定相应的 API，选择自己想要的策略，填写相应的配置属性。</p>
                    </div>
                </div>
                <div class="guide-footer">
                    <h4>如果您还有疑问</h4>
                    <ul>
                        <li>可以联系客户经理，进行协助。</li>
                        <li>可以在社区问答区发帖提问，另外请善用社区的搜索功能，你的疑问很可能之前已经有人问过了。</li>
                    </ul>
                </div>
            </div>
        </el-main>
        <el-footer>
            <Footer></Footer>
        </el-footer>
    </el-container>  
</template>

<script>
/* eslint-disable */
import Header from '@/components/header/Header.vue'
import Footer from '@/components/Footer/Footer.vue'

export default {
    components: {
        Header,
        Footer
    }
}
</script>

<style lang="scss">
    .guide{
        i{
            color: #928b89;
        }
        .el-main{
            // background-color: #252425;
            // padding: 40px 20px;
        }
        .guide-content{
            width: 50%;
            margin: 100px auto;
            background-color: #2f2d2d;
            color: #fff;
            text-align: left;
            padding: 10px 20px;
            border-radius: 5px;
            h2{
                padding: 10px 0;
                color: #fff;
                border-bottom: 1px solid #fff;
                margin-bottom: 20px;
            }
            .guide-step{
                padding: 10px 0;
                .step-content{
                    p{
                        padding: 5px 5px 5px 30px;
                        color: #928b89;
                    };
                }
            }
            .guide-footer{
                padding: 10px 0;
                border-top: 1px solid #fff;
                margin-top: 20px;
                ul{
                    padding-left: 30px;
                    li{
                        list-style-type: disc;
                        padding: 5px;
                        color: #928b89;
                    }
                }
            }
        }
    }
</style>
